export default __webpack_public_path__ + "static/media/about3.ad5191f7.png";